import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { ExpertHubLayout } from 'components/templates';
import { SuspenseLoader } from 'components/organisms';

const FormsList = React.lazy(() => import('./components/forms-list'));
const MarksSubmission = React.lazy(() => import('./components/marks-submission'));
const MarksSubmissionV2 = React.lazy(() => import('./components/marks-submission-v2'));
const CreateForm = React.lazy(() => import('./components/create-form'));
const CreateFormV2 = React.lazy(() => import('./components/create-form-v2'));

const FormsBase = () => (
  <React.Suspense fallback={<SuspenseLoader />}>
    <ExpertHubLayout>
      <Routes>
        <Route path="/" element={<FormsList />} />
        <Route path="/create" element={<CreateForm />} />
        <Route path="/edit-form/:formId" element={<CreateForm />} />
        <Route path="/v2/create" element={<CreateFormV2 />} />
        <Route path="/v2/edit-form/:formId" element={<CreateFormV2 />} />
        <Route path="/answered/:formId/:userSessionId" element={<MarksSubmission />} />
        <Route path="/v2/answered/:formId/:userSessionId" element={<MarksSubmissionV2 />} />
        <Route
          path="/answered/:formId/:userSessionId/:userModuleCompletionId"
          element={<MarksSubmission />}
        />
        <Route
          path="/v2/answered/:formId/:userSessionId/:userModuleCompletionId"
          element={<MarksSubmissionV2 />}
        />
      </Routes>
    </ExpertHubLayout>
  </React.Suspense>
);

export default FormsBase;
